<template>
  <div>
    <div class="row justify-content-center">
      <div
        class="col-8"
        v-if="
          initial_lead.properties.filter((x) => x.property_type == 'feedlot')
            .length == 0
        "
      >
        <div class="text-center text-grey">No feedlots registered.</div>
      </div>
      <div class="col-8">
        <div
          class="row"
          :class="
            initial_lead.properties.filter((x) => x.property_type == 'feedlot')
              .length == 1 && 'justify-content-center'
          "
        >
          <div
            v-for="(property, index) in initial_lead.properties.filter(
              (x) => x.property_type == 'feedlot'
            )"
            :key="index"
            class="col-6 mt-4"
            :class="index % 2 != 0 ? 'border-left' : ''"
          >
            <div class="text-uppercase text-light-gold mb-4 ml-2">
              {{ property.name }}
            </div>
            <div
              v-for="(mediaCollection, indexCol) in mediaCollections"
              :key="mediaCollection.id"
            >
              <div
                class="bg-light-grey shadow-sm p-3 my-2 mx-1 rounded text-dark-blue"
              >
                <div class="d-flex justify-content-between font-weight-bold">
                  {{ mediaCollection.name }}
                  <el-upload
                    class="upload-demo"
                    action=""
                    :file-list="fileList"
                    :on-change="
                      (file) =>
                        handleUpload(file, mediaCollection.id, property.pic)
                    "
                    :auto-upload="false"
                    :show-file-list="false"
                    v-if="onboardingAccount.is_completed == false"
                  >
                    <el-button class="btn-secondary">Upload</el-button>
                  </el-upload>
                </div>
                <div
                  v-for="file in fileList.filter(
                    (x) =>
                      x.media_collection_id == mediaCollection.id &&
                      x.pic == property.pic
                  )"
                  class="fa-sm mt-2"
                >
                  {{ file.name }}
                </div>
                <div
                  class="fa-sm text-grey mt-1"
                  v-if="initial_lead && initial_lead.onboarding_media"
                >
                  {{
                    initial_lead.onboarding_media.filter(
                      (f) =>
                        f.media_collection_id == mediaCollection.id &&
                        property.id &&
                        f.property_id == property.id
                    ).length
                  }}
                  files already saved for this section.
                </div>
              </div>
              <small class="text-grey ml-2">{{
                mediaCollection.message
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div class="d-flex justify-content-between">
        <el-button class="btn-secondary" @click="updateLead('prev')">
          Previous
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="onboardingAccount.is_completed == false"
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initial_lead: {
      type: Object,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      fileList: [],
      mediaCollections: [
        {
          id: 37,
          name: "Sale Contacts",
          message: "Proof of sale agreements currently in place",
        },
        {
          id: 36,
          name: "3 Months Closeout Data",
          message:
            "Data to show that average daily gain is in line with national standards.",
        },
        {
          id: 35,
          name: "NFAS",
        },
      ],
    };
  },
  methods: {
    handleUpload(file, media_collection_id, pic) {
      let document = file;
      document.media_collection_id = media_collection_id;
      document.pic = pic;
      console.log(this.fileList);
      this.fileList = this.fileList.filter(
        (f) => !(f.media_collection_id == media_collection_id && f.pic == pic)
      );
      console.log(this.fileList);
      this.fileList.push(document);
    },
    updateLead(step) {
      let lead = this.initial_lead;
      lead.documents = this.fileList;
      this.$emit("update-lead", lead, step);
    },
  },
};
</script>
